<template>
    <address-item-base :address="address">
        <template slot-scope="{ remove }">
            <div class="card">
                <div class="card-header">
                    <h4>
                        {{ address.name }}

                        <button
                            class="float-right"
                            @click.stop="remove"
                        >
                            {{ __('Delete') }}
                        </button>
                    </h4>
                </div>

                <div class="card-body">
                    <address>
                        {{ address.city }} <br>
                        {{ address.street }} {{ address.house_number }} <br>
                        {{ address.post_code }} <br>
                    </address>
                </div>
            </div>
        </template>
    </address-item-base>
</template>

<script>
export default {
    props: {
        address: {
            type: Object,
            required: true
        }
    }
}
</script>
